import { HIGH_PRIORITY_NEIGHBORHOODS_OF_NY, HIGH_PRIORITY_BOROUGHS_OF_NY } from "../constants/constants.js";
const handleNYCase = ({ state, neighborhood, borough }) => {
  let cityReplacement;
  return state === "NY" && (neighborhood && HIGH_PRIORITY_NEIGHBORHOODS_OF_NY.includes(neighborhood) ? cityReplacement = neighborhood : borough && HIGH_PRIORITY_BOROUGHS_OF_NY.includes(borough) && (cityReplacement = borough)), cityReplacement;
};
export {
  handleNYCase
};
//# sourceMappingURL=handleNYCase.js.map
